var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1h40v40H-1z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M35.864 13.242l-2.466 4.237c-.193.33-.193.73 0 1.06l2.466 4.237c.143.24.175.527.088.79a1.015 1.015 0 0 1-.545.602l-4.609 2.046a1.095 1.095 0 0 0-.654.873l-.618 4.8a.99.99 0 0 1-.421.697c-.237.166-.536.23-.824.175l-5.007-.942a1.184 1.184 0 0 0-1.057.327l-3.464 3.548c-.202.197-.48.308-.769.308-.29 0-.567-.111-.769-.308l-3.464-3.548a1.17 1.17 0 0 0-.838-.349 1.233 1.233 0 0 0-.22 0l-4.988.951a1.088 1.088 0 0 1-.824-.175.99.99 0 0 1-.42-.697l-.618-4.8a1.095 1.095 0 0 0-.655-.873L.593 24.168a1.015 1.015 0 0 1-.545-.602.958.958 0 0 1 .088-.79l2.466-4.237c.193-.33.193-.73 0-1.06L.136 13.242a.958.958 0 0 1-.088-.79c.087-.265.284-.482.545-.602L5.17 9.799c.363-.162.612-.493.654-.873l.618-4.8a.99.99 0 0 1 .421-.697c.237-.166.536-.23.824-.175l4.993.93c.388.07.787-.053 1.057-.328L17.201.308c.203-.197.48-.308.77-.308.289 0 .566.111.768.308l3.465 3.548c.27.275.669.399 1.057.327l4.993-.93c.288-.053.587.01.823.176a.99.99 0 0 1 .421.697l.618 4.8c.043.38.291.711.655.873l4.604 2.046c.26.12.458.338.545.602a.958.958 0 0 1-.088.79l.032.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    stroke: "#80959D",
    d: "M22.4 12L12 25.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.7,
    cy: 22.5,
    r: 2.5,
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 14.5,
    r: 2.5,
    fill: "rgba(21, 87, 191, 0.7)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.772490cfe500902f14984abd764d9ac3.svg";
export { ForwardRef as ReactComponent };